export const USERINFO = "userInfo/userInfo";
export const DICTIONARYLIST = "dictionaryList/dictionaryList";
export const CLEAR = "clear/clear";
export const CLIENT_TYPE = "login/clientType";
export const SITELIST = 'siteList/siteList';
export const MATERIALLIST = "materialList/materialList";
export const SEARCHNAME = "searchName/searchName";
export const PRODUCT = "product/product";
export const SETTING = "setting/setting";
export const defaultState = {
    userInfo: {
        token: null,
        customerId: null,
        customerType: 0
    },
    dictionaryList: [],
    clientType: 4, // 不使用用户的clientType,因为一个用户可能对应多个clentType的UserOpenId
    type:{
        mall:0,
        express:1
    },
    siteList:[],
    materialList:{},
    searchNameList: [],
    product:{},
    setting: {},
};
